import { render, staticRenderFns } from "./BasicCalendar.vue?vue&type=template&id=28855d25"
import script from "./BasicCalendar.vue?vue&type=script&lang=js"
export * from "./BasicCalendar.vue?vue&type=script&lang=js"
import style0 from "./BasicCalendar.vue?vue&type=style&index=0&id=28855d25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports